export class AwsOpenSearchIndexSelection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "index",
            "baseName": "index",
            "type": "string",
            "format": ""
        },
        {
            "name": "documentIds",
            "baseName": "documentIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsOpenSearchIndexSelection.attributeTypeMap;
    }
    constructor() {
    }
}
